import getAbbreviation from './unitAbbreviations'

/*
Header Properties:

Property Name | Type(s) | Description | Example
--------------------------------------------------------
text | String | header display value
value | Path | property path to value | 'x.y.z'

sortable | Boolean
sort | String | ['string', 'boolean', 'timestamp', 'numString', 'object', 'number'] | Which sort function to use
sortArrowInFront | Boolean | Default: False | position sort arrow arrow in front of the header text

align | String | text alignment
width | String | strict column width

filter | String | Vue.Filter to use to display the value
filterArgs | Arguments to pass to the filter function (i.e. a specific date format)

render | String, Function | 'fraction', 'boolean' | Because Vue.Filters only return text, we use
                                                    render to return components, or create custom
                                                    markup

** unit | String | unit of measure to append to the value

class | String, Array | any additional  classes to apply to the header cell
*/

export function certification () {
  return {
    text: 'Certification',
    value: 'certification',
    sortable: true,
    sort: 'string'
  }
}

export function color () {
  return {
    text: 'Color',
    value: 'color',
    sortable: true,
    sort: 'string'
  }
}

export function cut () {
  return {
    text: 'Cut',
    value: 'cut',
    sortable: true,
    sort: 'string'
  }
}

export function computerEaseNumber () {
  return {
    text: 'ComputerEase #',
    value: 'computerEaseNumber',
    sortable: true,
    sort: 'string'
  }
}

export function diameter () {
  return {
    text: 'Diameter (in)',
    value: 'diameter',
    sortable: true,
    sort: 'number',
    render: 'fraction',
    unit: 'inches'
  }
}

export function finish () {
  return {
    text: 'Finish',
    value: 'finish',
    sortable: true,
    sort: 'string'
  }
}

export function length (unit = 'inches') {
  const abbreviation = getAbbreviation(unit)
  return {
    text: `Length  (${abbreviation})`,
    value: 'length',
    sortable: true,
    sort: 'number',
    render: 'fraction',
    align: 'center',
    unit
  }
}

export function loadWeight () {
  return {
    text: 'Load Weight (lb)',
    value: 'loadWeight',
    sortable: true,
    sort: 'number',
    unit: 'lbs'
  }
}

export function manufacturer () {
  return {
    text: 'Manufacturer',
    value: 'manufacturer.name',
    sortable: true,
    sort: 'string'
  }
}

export function manufacturerNumber () {
  return {
    text: 'Manufacturer #',
    value: 'manufacturerNumber',
    sortable: true,
    sort: 'string'
  }
}

export function name () {
  return {
    text: 'Name',
    value: 'name',
    sortable: true,
    sort: 'string'
  }
}

export function species () {
  return {
    text: 'Species',
    value: 'species',
    sortable: true,
    sort: 'string'
  }
}

export function thickness (unit = 'inches') {
  const abbreviation = getAbbreviation(unit)
  return {
    text: `Thickness  (${abbreviation})`,
    value: 'thickness',
    sortable: true,
    sort: 'number',
    render: 'fraction',
    align: 'center',
    unit
  }
}

export function type () {
  return {
    text: 'Type',
    value: 'type',
    sortable: true,
    sort: 'string'
  }
}

export function width (unit = 'inches') {
  const abbreviation = getAbbreviation(unit)
  return {
    text: `Width  (${abbreviation})`,
    value: 'width',
    sortable: true,
    sort: 'number',
    render: 'fraction',
    unit: 'inches',
    align: 'center'
  }
}
